import { render, staticRenderFns } from "./ConfigCamarasStreamax.vue?vue&type=template&id=4a25f1d7&scoped=true&"
import script from "./ConfigCamarasStreamax.vue?vue&type=script&lang=ts&"
export * from "./ConfigCamarasStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigCamarasStreamax.vue?vue&type=style&index=0&id=4a25f1d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a25f1d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4a25f1d7', component.options)
    } else {
      api.reload('4a25f1d7', component.options)
    }
    module.hot.accept("./ConfigCamarasStreamax.vue?vue&type=template&id=4a25f1d7&scoped=true&", function () {
      api.rerender('4a25f1d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Streamax/ConfigCamarasStreamax.vue"
export default component.exports